import Swiper from 'swiper';
import { useEffect, useRef } from 'react';
import { Navigation } from 'swiper/modules';

import 'swiper/scss';
import 'swiper/scss/navigation';
import './CardList.scss';
import { ProductType } from '../../types';
import Card from '../Card/Card';

type CardListProps = {
  products: ProductType[];
  isTwoItems?: Boolean;
};

export default function CardList({
  products,
  isTwoItems,
}: CardListProps): JSX.Element | null {
  const sliderRef = useRef<null | HTMLDivElement>(null);
  const prevButtonRef = useRef<null | HTMLDivElement>(null);
  const nextButtonRef = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    if (!sliderRef.current) {
      return;
    }

    if (isTwoItems) {
      new Swiper(sliderRef.current, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 20,
        loop: false,
        pagination: false,
        navigation: {
          prevEl: prevButtonRef.current,
          nextEl: nextButtonRef.current,
        },
        breakpoints: {
          1500: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1280: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          600: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          459: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      });

      return;
    }

    new Swiper(sliderRef.current, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      loop: false,
      pagination: false,
      navigation: {
        prevEl: prevButtonRef.current,
        nextEl: nextButtonRef.current,
      },
      breakpoints: {
        1500: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        800: {
          slidesPerView: 2.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        600: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        459: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
      },
    });
  }, [isTwoItems]);

  return (
    <div className={`m-slider-container ${isTwoItems ? 'hero-mini' : ''}`}>
      <div className="swiper-container" ref={sliderRef}>
        <div className="swiper-wrapper">
          {products.map((product) => (
            <Card product={product} key={product.productId} />
          ))}
        </div>
      </div>
      <div className="swiper-button-prev" ref={prevButtonRef} />
      <div className="swiper-button-next" ref={nextButtonRef} />
    </div>
  );
}

//

/////// OLD BREAKPOINTS

// breakpoints: {
//   1500: {
//     slidesPerView: 4,
//   },
//   1280: {
//     slidesPerView: 4,
//   },
//   1024: {
//     slidesPerView: 3,
//   },
//   768: {
//     slidesPerView: 2,
//   },
//   600: {
//     slidesPerView: 2,
//   },
//   459: {
//     slidesPerView: 1,
//   },
// },
